import React, { useContext, useRef } from 'react';

import { Toast, ToastMessage } from 'primereact/toast';

export const GrowlContext = React.createContext<{
  showGrowl: (message: ToastMessage) => void;
  clearGrowl: () => void;
}>({ showGrowl: (_message: ToastMessage) => {}, clearGrowl: () => {} });

export const GrowlProvider: React.FC<{}> = (props) => {
  const growl = useRef<any>(null);

  return (
    <GrowlContext.Provider
      value={{
        showGrowl: (message: ToastMessage) => {
          growl.current.show(message);
        },
        clearGrowl: () => {
          growl.current.clear();
        },
      }}
    >
      {props.children}
      <Toast ref={growl} />
    </GrowlContext.Provider>
  );
};

export const useGrowlContext = () => {
  return useContext(GrowlContext);
};
